import React, { useState } from "react";
import { Nav, Logo, NavLink, Bars, NavMenu, ResumeBtn } from "./HeaderElements";
import styled from "styled-components"; // Import styled-components

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const CancelButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    color: black;
    font-size: 1.5rem;
    cursor: pointer;
    display: ${({ show }) => (show ? "block" : "none")}; 
  `;
  

  return (
    <div className="Container" style={{ padding: 10 }}>
      <Nav style={{ marginTop: "20px", borderRadius: "100px", padding: "20px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", display: 'flex', justifyContent: 'center' }}> 
        <Bars onClick={toggleMenu} />
        
        <NavMenu show={showMenu} className={showMenu ? "active" : ""}>
          <NavLink className="menu-item" to="projects" onClick={toggleMenu}>Projects</NavLink>
          <NavLink className="menu-item" to="about" onClick={toggleMenu}>About</NavLink>
          <NavLink className="menu-item" to="contact" onClick={toggleMenu}>Contact</NavLink>
          <ResumeBtn
            href="/Resume.docx" 
            download 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn PrimaryBtn"
            style={{
              padding: "10px 20px",
              backgroundColor: "#333",
              color: "#fff",
              borderRadius: "500px",
              fontWeight: "bold",
              textDecoration: "none",
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              marginTop: "20px", 
            }}
            onClick={toggleMenu} 
          >
            Resume
          </ResumeBtn>
          <CancelButton show={showMenu} onClick={toggleMenu}>X</CancelButton> {/* Show cancel button only when menu is open */}
        </NavMenu>
        <Logo to="/" onClick={toggleMenu}>
          <img
            src="/IMG_1609.PNG"
            alt="Character SVG Vector Icon"
            style={{
              marginTop: "6px",
              width: "128px", 
              borderRadius: "50px",
              padding: "17px",
              boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.1)",
              marginLeft: "-15px", 
              marginRight: "-15px", 
              display: "inline-block", 
            }}
          />
        </Logo>
      </Nav>
    </div>
  );
};

export default Header;
